export enum CopilotExperimentKeys {
    CatchUpNeedsAction = 'catchup-needs-action',
    CatchUpNeedsReply = 'catchup-needs-reply',
    CatchUpNeedsSchedule = 'catchup-needs-schedule',
    HeadlinesSummary = 'headlines-summary',
    HeadlinesInteractivePrefix = 'headlines-interactive-prefix',
    PeopleNotesAnalysis = 'topic-generation',
    ProfileGeneration = 'profile-generation',
    TopicsBizchatPrompt = 'topics-bizchat-prompt',
    InboxBriefingsMorning = 'inbox-briefings-morning',
    InboxBriefingsEvening = 'inbox-briefings-evening',
}

export enum CopilotExperimentStorageKey {
    Scenarios = 'scenarios',
    Prompts = 'prompts',
}
